import { ActionProps } from "../../ts";
import { LIST_OF_PROGRAMS, LIST_OF_PROGRAMS_ERROR } from "../ActionTypes";

const initialState = { programs: null };

const programStore = (state: any = initialState, action: ActionProps) => {
  const { type, payload } = action;
  switch (type) {
    case LIST_OF_PROGRAMS: {
      return {
        ...state,
        programs: payload,
      };
    }
    case LIST_OF_PROGRAMS_ERROR: {
      return {
        ...state,
        programs: null,
      };
    }
    default:
      return state;
  }
};

export default programStore;